import React from 'react'
import { Route, Link } from 'react-router-dom'
import { connect } from 'react-redux'

// import { userActions } from '../../_actions'

class NavMenu extends React.Component {
  // componentDidMount() {
  //     this.props.dispatch(userActions.getAll())
  // }
  render() {
    const { user } = this.props;
    return (
      <ul className="nav">


        {user && user.role === 0 &&
          <Route path="/admin" exact>
            {({ match }) => <li className={match ? 'nav-item root-li active' : 'nav-item root-li'}><Link to="/admin"><i className="mdi mdi-home-outline"></i><p>داشبورد</p></Link></li>}
          </Route>
        }
        {user && user.role === 0 &&
          <Route path="/admin/union" exact>
            {({ match }) => <li className={match ? 'nav-item root-li active' : 'nav-item root-li'}><Link to="/admin/union"><i className="mdi mdi-checkbox-blank-circle-outline mdi-18px"></i><p>اتحادیه ها</p></Link></li>}
          </Route>
        }
        {user && (user.role === 0 || user.permissions.includes(1)) &&
          <Route path="/admin/teacher" exact>
            {({ match }) => <li className={match ? 'nav-item root-li active' : 'nav-item root-li'}><Link to="/admin/teacher"><i className="mdi mdi-checkbox-blank-circle-outline mdi-18px"></i><p>اساتید</p></Link></li>}
          </Route>
        }
        {user && user.role === 0 &&
          <Route path="/admin/lesson" exact>
            {({ match }) => <li className={match ? 'nav-item root-li active' : 'nav-item root-li'}><Link to="/admin/lesson"><i className="mdi mdi-checkbox-blank-circle-outline mdi-18px"></i><p>دروس</p></Link></li>}
          </Route>
        }

        {user && (user.role === 0 || user.permissions.includes(5)) &&
          <Route path="/admin/class" exact>
            {({ match }) => <li className={match ? 'nav-item root-li active' : 'nav-item root-li'}><Link to="/admin/class"><i className="mdi mdi-checkbox-blank-circle-outline mdi-18px"></i><p>کلاس های آموزشی</p></Link></li>}
          </Route>

        }
        {user && (user.role === 0 || user.role === 1) &&
          <Route path="/admin/member" exact>
            {({ match }) => <li className={match ? 'nav-item root-li active' : 'nav-item root-li'}><Link to="/admin/member"><i className="mdi mdi-checkbox-blank-circle-outline mdi-18px"></i><p>شرکت کنندگان</p></Link></li>}
          </Route>
        }
        {user && (user.role === 0 || user.permissions.includes(0)) &&
          <Route path="/admin/member/new" exact>
            {({ match }) => <li className={match ? 'nav-item root-li active' : 'nav-item root-li'}><Link to="/admin/member/new"><i className="mdi mdi-checkbox-blank-circle-outline mdi-18px"></i><p>ثبت شرکت کننده جدید</p></Link></li>}
          </Route>
        }
        {user && (user.role === 0 || user.permissions.includes(4)) &&
          <Route path="/admin/member/attendance" exact>
            {({ match }) => <li className={match ? 'nav-item root-li active' : 'nav-item root-li'}><Link to="/admin/member/attendance"><i className="mdi mdi-checkbox-blank-circle-outline mdi-18px"></i><p>حضور و غیاب</p></Link></li>}
          </Route>
        }
        {user && (user.role === 0 || user.permissions.includes(6)) &&
          <Route path="/admin/payment" exact>
            {({ match }) => <li className={match ? 'nav-item root-li active' : 'nav-item root-li'}><Link to="/admin/payment"><i className="mdi mdi-checkbox-blank-circle-outline mdi-18px"></i><p>گزارشات مالی</p></Link></li>}
          </Route>
        }
        {user && (user.role === 0 || user.permissions.includes(6)) &&
          <Route path="/admin/Question" exact>
            {({ match }) => <li className={match ? 'nav-item root-li active' : 'nav-item root-li'}><Link to="/admin/Question"><i className="mdi mdi-checkbox-blank-circle-outline mdi-18px"></i><p>سوالات امتحانی</p></Link></li>}
          </Route>
        }
        {user && user.role === 0 &&
          <Route path="/admin/message" exact>
            {({ match }) => <li className={match ? 'nav-item root-li active' : 'nav-item root-li'}><Link to="/admin/message"><i className="mdi mdi-checkbox-blank-circle-outline mdi-18px"></i><p>پیام های کاربران</p></Link></li>}
          </Route>
        }
        {user && user.role === 0 &&
          <Route path="/admin/user" exact>
            {({ match }) => <li className={match ? 'nav-item root-li active' : 'nav-item root-li'}><Link to="/admin/user"><i className="mdi mdi-checkbox-blank-circle-outline mdi-18px"></i><p>مدیریت کاربران</p></Link></li>}
          </Route>
        }


      </ul>
    );
  }
}


function mapStateToProps(state) {
  const { authentication } = state;
  const { user } = authentication;
  return {
    user
  };
}

const connectedNavMenu = connect(mapStateToProps)(NavMenu);
export { connectedNavMenu as NavMenu };